let mobileAuthToken: string | null = null

export const setMobileAuthToken = (token: string | null) => {
  mobileAuthToken = token
}

export const getMobileAuthToken = () => mobileAuthToken

export const clearMobileAuthToken = () => {
  mobileAuthToken = null
}
